module.exports = __webpack_public_path__ + "static/media/patrol(14).a757f7cb.PNG";